import s, { useState as u, useMemo as p } from "react";
import { c, t as l } from "./app-a75c1d35.mjs";
import { B as i } from "./Block-9b78bd10.mjs";
const C = "tabs__sub-heading", L = "desktop", _ = "tabs__list", g = "tabs__content", I = "tabs__listItem", k = "tabs__listItem--current", n = {
  tabsSubHeading: C,
  desktop: L,
  tabsList: _,
  tabsContent: g,
  tabsListItem: I,
  tabsListItemCurrent: k
};
function y(o) {
  const { tabData: e, sectionHeading: b } = o, [a, d] = u(e[0].uid), m = (t) => {
    d(t);
  }, r = p(
    () => e.find((t) => a == t.uid)?.content ?? null,
    [a, e]
  );
  return /* @__PURE__ */ s.createElement(
    i,
    {
      topPadding: i.Padding.SMALL,
      bottomPadding: i.Padding.LARGE,
      "data-testid": "tabs-block"
    },
    /* @__PURE__ */ s.createElement(
      i.Content,
      {
        className: c(n.tabsContent),
        "data-testid": "tabs-content"
      },
      /* @__PURE__ */ s.createElement("div", { className: c(n.tabsSubHeading, l.headingSection) }, b),
      /* @__PURE__ */ s.createElement("div", { className: c(n.tabsList), "data-testid": "tabs-list" }, e.map((t) => /* @__PURE__ */ s.createElement(
        f,
        {
          key: t.uid + t.tabTitle,
          ...t,
          onClick: m,
          activeTabId: a,
          "data-testid": "tabs"
        }
      ))),
      r
    )
  );
}
function f({
  uid: o,
  tabTitle: e,
  activeTabId: b,
  onClick: a
}) {
  const d = c(
    n.tabsListItem,
    o === b && n.tabsListItemCurrent,
    l.textsComponentTitleBold
  );
  return /* @__PURE__ */ s.createElement("button", { type: "button", className: d, onClick: () => a(o) }, e);
}
export {
  y as Tabs
};
//# sourceMappingURL=Tabs.js.map
